import $ from 'jquery';
// import mpro from '../../mpro';

/**
	 * Process extra data in add to cart items
	 *
	 * @param {JQuery.NameValuePair[]} data
	 */
const beforeAddToCart = function(data) {

	const parsedData = data.reduce((all, v) => {
		all[v.name] = (
			typeof all[v.name] !== 'undefined' ?
				(Array.isArray(all[v.name]) ? all[v.name].concat([v.value]) : [all[v.name], v.value]) :
				v.value
		);

		return all;
	}, {});

	// Copy subscription data from the base product to every variant
	if (typeof parsedData['items[product][subscription_period]'] !== 'undefined') {
		const subscriptionPeriod = parsedData['items[product][subscription_period]'];
		let foundVariants = false;

		for (const item of Object.keys(parsedData)) {
			const found = item.match(/items\[(\d+)]\[variant_id]/);
			if (found) {
				foundVariants = true;
				parsedData['items[' + found[1] + '][subscription_period]'] = subscriptionPeriod;
			}
		}

		if (foundVariants) {
			delete parsedData['items[product][subscription_period]'];
		}
	}

	// Copy user fields data from the base product to every variant
	for (const searchUserFields of Object.keys(parsedData)) {
		if (searchUserFields.startsWith('items[product][user_fields]')) {
			const userFields = parsedData[searchUserFields];
			let foundVariants = false;

			for (const item of Object.keys(parsedData)) {
				const found = item.match(/items\[(\d+)]\[variant_id]/);
				if (found) {
					foundVariants = true;
					parsedData['items[' + found[1] + '][user_fields]' + searchUserFields.slice('items[product][user_fields]'.length)] = userFields;
				}
			}

			if (foundVariants) {
				delete parsedData[searchUserFields];
			}
		}
	}

	// Update gifts quantity based on quantity input
	if (typeof parsedData['items[product][qty]'] !== 'undefined') {

		for (const item of Object.keys(parsedData)) {
			const found = item.match(/items\[gift_(\d+)_(\d+)]\[qty]/);
			if (found && (typeof (parsedData['items[gift_' + found[1] + '_' + found[2] + '][source_qty]']) !== 'undefined')) {
				const targetQty = Number.parseInt(parsedData['items[gift_' + found[1] + '_' + found[2] + '][qty]'], 10) || 1;
				const sourceQty = Number.parseInt(parsedData['items[gift_' + found[1] + '_' + found[2] + '][source_qty]'], 10) || 1;
				const selectedQty = Number.parseInt(parsedData['items[product][qty]'], 10) || 1;

				parsedData['items[gift_' + found[1] + '_' + found[2] + '][qty]'] = Math.ceil(selectedQty / sourceQty) * targetQty;
			}
		}
	}

	return $.param(parsedData);
};

/**
 * Handle add to cart events
 *
 * @this {HTMLElement}
 * @param {JQuery.TriggeredEvent} e
 */
const addToCartHandler = async function(e) {
	e.preventDefault();

	const $trigger = $(this);
	const triggerElement = this;
	const targetIsFrom = $trigger.is('form');
	let $button;
	let sendData;
	const extraOptions = $trigger.data() || {};

	// Target element is a form
	if (targetIsFrom) {
		$button = $trigger.find('button[type=submit]');
		sendData = beforeAddToCart($trigger.serializeArray());
		// sendData = $trigger.serialize();
	}
	// Target element is a button/link
	else {
		$button = $trigger;

		// Send the whole parent form (or selected form)
		if ('cartAddForm' in extraOptions) {
			// Select form by id of current form
			const $form = extraOptions.cartAddForm && (typeof extraOptions.cartAddForm === 'string') ? $(extraOptions.cartAddForm) : $trigger.closest('form');

			if ($form.length === 0) {
				console.warn('Could not find form target for \'cart-add\' action', extraOptions.cartAddForm);
				return;
			}

			sendData = beforeAddToCart($form.serializeArray());
			// sendData = $form.serialize();
		}
		// Send only data provided in the link/button (item data cannot be mixed with form-data)
		else {

			sendData = { items: $trigger.data('cart-add') };

			// Items must be array
			if (!Array.isArray(sendData.items) || sendData.items.length === 0) {
				mpro.toast('error', mpro.langvar('error_unknown'));
				return;
			}
		}
	}

	// Cart api
	const { cart } = mpro.shop;
	// Get override success/error actions from extra options
	const overrideActions = cart.getOverrideActions(extraOptions);

	try {
		// Show loading animation and disabled the button
		mpro.addButtonLoading($button);
		// Execute the remote action
		const res = await cart.add(sendData);
		// Execute all defined success handlers for the current action
		cart.runSuccessHandlers('add', res, triggerElement, overrideActions.success);
	}
	catch (error) {
		// Default error handlers
		cart.runErrorHandlers('add', error, triggerElement, overrideActions.error);
	}
	finally {
		mpro.removeButtonLoading($button);
		if (targetIsFrom) {
			mpro.restoreSubmitButton($button);
		}
	}
};

/**
 * Handle cart quantity update events
 *
 * @param {HTMLElement} triggerElement
 * @param {'update'|'delete'} actionType
 */
const updateCartHandler = async function(triggerElement, actionType = 'update') {

	const $trigger = $(triggerElement);
	const triggerIsButton = $trigger.is('button,a');
	let sendData;
	const extraOptions = $trigger.data() || {};
	const dataName = mpro.camelize('cart-' + actionType);
	const dataNameContainer = dataName + 'Container';
	const dataNameTarget = dataName + 'Target';

	// Get update data from the parent context
	if (dataNameContainer in extraOptions) {

		const containerSelector = extraOptions[dataNameContainer];
		const $parent = containerSelector === true || containerSelector === '' ? $trigger.parent() : $(containerSelector);

		if ($parent.length === 0) {
			console.warn('Could not find parent target for \'cart-update\' action %o on %o', containerSelector, dataNameContainer);
			return;
		}

		sendData = $parent.find('input,select,textarea').not(':disabled').serialize();
	}
	// Get update data from attributes and input value
	else {
		const data = $trigger.data(dataName);

		// Items must be array
		if (!Array.isArray(data) || (data.length === 0)) {
			mpro.toast('error', mpro.langvar('error_unknown'));
			return;
		}

		sendData = { items: data };
	}

	// Cart api
	const { cart } = mpro.shop;
	// Get override success/error actions from extra options
	const overrideActions = cart.getOverrideActions(extraOptions);

	// Remove tooltips/popovers
	if (actionType === 'delete') {
		mpro.closeSimpleOverlays();
	}

	try {

		// Disable button
		if (triggerIsButton) {
			mpro.addButtonLoading($trigger);
		}
		// Disable input
		else {
			$trigger.prop('disabled', true);
		}

		// Execute the remote action
		const res = await cart.update(sendData);
		// Execute all defined success handlers for the current action
		cart.runSuccessHandlers(actionType, res, triggerElement, overrideActions.success);

		// Remove the target container for the 'delete' action
		if ((actionType === 'delete') && extraOptions[dataNameTarget]) {
			$(extraOptions[dataNameTarget]).hide('fast', function() {
				$(this).remove();
				// Remove tooltips/popovers
				mpro.closeSimpleOverlays();
			});
		}
	}
	catch (error) {
		// Default error handlers
		cart.runErrorHandlers(actionType, error, triggerElement, overrideActions.error);
	}
	finally {
		// Enable button
		if (triggerIsButton) {
			mpro.removeButtonLoading($trigger);
		}
		// enable input
		else {
			$trigger.prop('disabled', false);
		}
	}
};

/**
 * Handle cart modify events
 *
 * @this {HTMLElement}
 * @param {JQuery.TriggeredEvent} e
 */
const modifyCartHandler = async function(e) {
	e.preventDefault();

	const $trigger = $(this);
	const triggerElement = this;
	const $button = $trigger.find('button[type=submit]');
	const sendData = $trigger.serialize();
	const extraOptions = $trigger.data() || {};

	// Cart api
	const { cart } = mpro.shop;
	// Get override success/error actions from extra options
	const overrideActions = cart.getOverrideActions(extraOptions);

	try {
		// Show loading animation and disabled the button
		mpro.addButtonLoading($button);
		// Execute the remote action
		const res = await cart.modify(sendData);
		// Execute all defined success handlers for the current action
		cart.runSuccessHandlers('modify', res, triggerElement, overrideActions.success);
	}
	catch (error) {
		// Default error handlers
		cart.runErrorHandlers('modify', error, triggerElement, overrideActions.error);
	}
	finally {
		mpro.removeButtonLoading($button);
		mpro.restoreSubmitButton($button);
	}
};

/**
 * Handle cart coupon events
 *
 * @param {HTMLElement} triggerElement
 * @param {'add'|'delete'} actionType
 */
const couponHandler = async function(triggerElement, actionType = 'add') {

	const $trigger = $(triggerElement);
	const targetIsFrom = $trigger.is('form');
	const action = actionType + 'Coupon';
	let $button;
	let sendData;
	const extraOptions = $trigger.data() || {};

	// Target element is a form
	if (targetIsFrom) {
		$button = $trigger.find('button[type=submit]');
		sendData = $trigger.serialize();
	}
	// Target element is a button/link
	else {
		$button = $trigger;

		if ('cartCouponForm' in extraOptions) {
			// Select form by id of current form
			const $form = extraOptions.cartCouponForm && (typeof extraOptions.cartCouponForm === 'string') ? $(extraOptions.cartCouponForm) : $trigger.closest('form');

			if ($form.length === 0) {
				console.warn(`Could not find form target for \'cart-${actionType}-coupon\' action`, extraOptions.cartCouponForm);
				return;
			}

			sendData = $form.serialize();
		}
		// Only the apply action send data
		else if (actionType === 'add') {
			sendData = { coupon_code: $trigger.data('cart-add-coupon') };

			// Items must be array
			if (!sendData.coupon_code) {
				mpro.toast('error', mpro.langvar('error_unknown'));
				return;
			}
		}
	}

	// Cart api
	const { cart } = mpro.shop;
	// Get override success/error actions from extra options
	const overrideActions = cart.getOverrideActions(extraOptions);

	try {
		// Show loading animation and disabled the button
		mpro.addButtonLoading($button);
		// Execute the remote action
		const res = await cart[action](sendData);
		// Execute all defined success handlers for the current action
		cart.runSuccessHandlers(action, res, triggerElement, overrideActions.success);
	}
	catch (error) {
		// Default error handlers
		cart.runErrorHandlers(action, error, triggerElement, overrideActions.error);
	}
	finally {
		mpro.removeButtonLoading($button);
		if (targetIsFrom) {
			mpro.restoreSubmitButton($button);
		}
	}
};

/**
 * Handle add to cart events
 *
 * @this {HTMLElement}
 * @param {JQuery.TriggeredEvent} e
 */
const throttleUpdateCart = function(e) {
	const $elem = $(this);
	const data = $elem.data();

	if (data._throttleTimer) {
		window.clearTimeout(data._throttleTimer);
	}

	data._throttleTimer = window.setTimeout(updateCartHandler, 833, this);
};

// Add init function that is executed only on first dom-ready (it should contain only document/body delegate handlers)
mpro.addInitDelegate(($) => {

	const $B = mpro.get$B();

	// Handle click event for add-to-cart buttons
	$B.on('click.addToCart', 'a[data-cart-add],button[data-cart-add],div[data-cart-add],span[data-cart-add],a[data-cart-add-form],button[data-cart-add-form],div[data-cart-add-form],span[data-cart-add-form]', addToCartHandler);
	$B.on('submit.addToCart', 'form[data-cart-add]', addToCartHandler);

	// Handle click event for update-cart spinners
	$B.on('change.updateCart', 'input[data-cart-update],select[data-cart-update],input[data-cart-update-container],select[data-cart-update-container]', throttleUpdateCart);
	$B.on('click.updateCart', 'a[data-cart-update],button[data-cart-update],a[data-cart-update-container],button[data-cart-update-container]', (e) => {
		e.preventDefault();
		updateCartHandler(e.currentTarget);
	});

	$B.on('submit.modifyCart', 'form[data-cart-modify]', modifyCartHandler);

	$B.on('click.deleteCart', 'a[data-cart-delete],button[data-cart-delete]', (e) => {
		e.preventDefault();
		updateCartHandler(e.currentTarget, 'delete');
	});

	$B.on('click.addCoupon', 'a[data-cart-add-coupon],button[data-cart-add-coupon],div[data-cart-add-coupon],span[data-cart-add-coupon]', (e) => {
		e.preventDefault();
		couponHandler(e.currentTarget, 'add');
	});

	$B.on('submit.addCoupon', 'form[data-cart-add-coupon]', (e) => {
		e.preventDefault();
		couponHandler(e.currentTarget, 'add');
	});

	$B.on('click.deleteCoupon', '[data-cart-delete-coupon]', (e) => {
		e.preventDefault();
		couponHandler(e.currentTarget, 'delete');
	});
});
